import { LoadingButton } from '@mui/lab'
import { Autocomplete, Box, Button, Checkbox, CircularProgress, FormControl, FormControlLabel, InputAdornment, InputLabel, MenuItem, Select, Stack, TextField, Typography } from '@mui/material'
import { debounce } from 'lodash'
import React, { useContext, useEffect, useState } from 'react'
import { useAuthContext } from 'src/auth/useAuthContext'
import CustomInput from 'src/components/customerinput/CustomerInput'
import CustomModal from 'src/components/customerinput/CustomModal'
import { notify } from 'src/components/notify'
import { VendorContext } from 'src/contexts/VendorContext'
import createCampianGroup from 'src/services/campian/createGroup'
import updateCampianGroup from 'src/services/campian/updateGroup'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import searchIcon from 'src/assets/icons/searchicon.svg';
export default function CreateGroupModal({ open, close, editData, setReload }) {
    const { user } = useAuthContext()
    const { vendors, getVendor } = useContext(VendorContext);
    const [vendorId, setVendorId] = useState([])
    const [loading, setLoading] = useState(false)
    const [value, setValue] = useState('')
    const handleSubmit = async () => {
        try {
            if (!value.trim()) {
                return notify('Group name is required.')
            }
            if (value.length < 3) {
                return notify('Group name must contain at least 3 character(s).')
            }
            setLoading(true)
            let data;
            if (editData) {
                data = await updateCampianGroup(user, { name: value, vendor: vendorId.map((it) => it._id) || undefined }, editData?._id)
            } else {
                data = await createCampianGroup(user, { name: value, vendor: vendorId?.map((it) => it._id) || undefined })
            }
            if (data) {
                if (editData) {
                    notify('Update Successfully.', "success")

                } else {
                    notify('Created Successfully.', "success")
                }
                setReload((prev) => !prev)
                close()
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false)

        }

    }

    useEffect(() => {
        if (editData && vendors?.length) {
            setValue(editData?.name)
            setVendorId(editData?.vendorsData || [])
        }
    }, [open, vendors]);
    useEffect(() => {
        const fetchVendor = async () => {
            try {
                await getVendor(0, false);
            } catch (error) {
                console.error(error);
            } finally {
            }
        };
        fetchVendor();
    }, [getVendor]);


    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;

    const checkedIcon = <CheckBoxIcon fontSize="small" />;
    const SELECT_ALL_OPTION = { _id: 'all', name: 'Select All' };
    return (
        <div>
            <CustomModal open={open} close={close} heading={editData ? "Update Group" : "Create Group"} action={<LoadingButton disabled={loading} loading={loading} onClick={handleSubmit} variant="contained">Confirm</LoadingButton>}>
                <Stack spacing={1}>

                    <Stack spacing={1}>
                        <Typography variant="h6">Select Partners</Typography>
                        <Autocomplete
                            multiple
                            id="checkboxes-tags-demo"
                            options={[SELECT_ALL_OPTION, ...vendors]}
                            disableCloseOnSelect
                            limitTags={2}
                            getOptionLabel={(option) => option.name}
                            isOptionEqualToValue={(option, value) => option._id === value._id}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                const isSelectAll = option._id === 'all';
                                const allSelected = vendorId.length === vendors.length;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            // checked={selected}
                                            checked={isSelectAll ? allSelected : selected}
                                        />
                                        {option.name}
                                    </li>
                                );
                            }}
                            value={vendorId}
                            onChange={(_, val) => {
                                const isSelectAllClicked = val.find(v => v._id === 'all');
                                if (isSelectAllClicked) {
                                    if (vendorId.length == vendors.length) {
                                        setVendorId([]);
                                    } else {
                                        const formatted = vendors.map(({ _id, name }) => ({ _id, name }));
                                        setVendorId(formatted);
                                    }
                                } else {
                                    const filtered = val.filter(v => v._id !== 'all');
                                    const formattedVal = filtered.map(({ _id, name }) => ({ _id, name }));
                                    setVendorId(formattedVal);
                                }
                            }}

                            style={{ width: "100%" }}
                            renderInput={(params) => (
                                <TextField {...params} label="Select Partners"
                                    placeholder="Select Partners" />
                            )}
                        />
                    </Stack>
                    <CustomInput
                        label="Group Name"
                        input={
                            <TextField fullWidth placeholder='Enter group name.'
                                value={value}
                                onChange={(e) => setValue(e.target.value)}

                            />
                        }
                    />
                </Stack>
            </CustomModal>
        </div>
    )
}
